import { connect } from "react-redux";
import LoadingBar from "react-top-loading-bar";
import React, { Fragment, useEffect, useRef } from "react";
import IdleUserModal from "../../../shared/hooks/IdleUserModal";
import { shopifyConstants } from "../../../constants";
import { authenticationActions, shopifyActions } from "../../../redux/actions";
import DraftConfirmationModal from "../../../views/SellAndTrade/Shared/DraftConfirmationModal";
import ToastPrintLabelModal from "../../../shared/components/ToastPrintLabel/ToastPrintLabelModal";
import OrderDetailsModal from "../../../views/SellAndTrade/Orders/OrderDetailsModal/OrderDetailsModal";
import {
  handleMarkOrderAsOpen,
  handleMarkOrderAsReady,
  handleMarkOrderAsFulfilled,
  handleTransferToLocation,
} from "../../../shared/utility";
import ConfirmationModalRedux from "../../../shared/components/modal/ConfirmationModalRedux";

const MainWrapper = ({
  children,
  currentStore,
  spinnerArray,
  employeeLogout,
  isAuthenticated,
  isPrintLabelModal,
  isDraftConfirmationModal,
  isShowConfirmationModalRedux,
  isShowShopifyOrderNotificationModal,
  shopifyOrderNotificationModalDetails,
  setIsShowShopifyOrderNotificationModal,
  updateShopifyOrderStatus,
}) => {
  const loadingBarRef = useRef(null);
  const prevLengthRef = useRef(spinnerArray.length);
  // const { reset } = useIdleUserClose(10000);

  const toggleOrderDetailModal = () => {
    setIsShowShopifyOrderNotificationModal(
      !isShowShopifyOrderNotificationModal
    );
  };

  useEffect(() => {
    const prevLength = prevLengthRef.current;
    const currentLength = spinnerArray.length;

    if (prevLength === 0 && currentLength > 0) {
      loadingBarRef.current.continuousStart();
    } else if (currentLength === 0 && prevLength > 0) {
      loadingBarRef.current.complete();
    }

    // Update the previous length value
    prevLengthRef.current = currentLength;
  }, [spinnerArray]);

  return (
    <Fragment>
      <LoadingBar
        color="#6a18ed"
        ref={loadingBarRef}
        height={3}
        shadow={true}
      />
      {isDraftConfirmationModal ? <DraftConfirmationModal /> : ""}
      <ToastPrintLabelModal />
      {isShowConfirmationModalRedux && <ConfirmationModalRedux />}
      {isShowShopifyOrderNotificationModal ? (
        <OrderDetailsModal
          currentStore={currentStore}
          handleMarkOrderAsOpen={handleMarkOrderAsOpen}
          toggleOrderDetailModal={toggleOrderDetailModal}
          handleMarkOrderAsReady={handleMarkOrderAsReady}
          orderDetail={shopifyOrderNotificationModalDetails}
          updateShopifyOrderStatus={updateShopifyOrderStatus}
          defaultGridState={shopifyConstants.NOTIFICATION_MODAL}
          isShowOrderDetail={isShowShopifyOrderNotificationModal}
          handleMarkOrderAsFulfilled={handleMarkOrderAsFulfilled}
          handleTransferToLocation={handleTransferToLocation}
        />
      ) : (
        <></>
      )}
      <div>
        <div>
          {isAuthenticated && <IdleUserModal employeeLogout={employeeLogout} />}
          {children}
        </div>
      </div>
    </Fragment>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
  isPrintLabelModal: state.printer.isPrintLabelModal,
  isAuthenticated: state.authentication.isAuthenticated,
  isDraftConfirmationModal: state.transaction.isDraftConfirmationModal,
  isShowConfirmationModalRedux: state.system.confirmationModalRedux.isShow,
  isShowShopifyOrderNotificationModal:
    state.shopify.isShowShopifyOrderNotificationModal,
  shopifyOrderNotificationModalDetails:
    state.shopify.shopifyOrderNotificationModalDetails,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  employeeLogout: () => dispatch(authenticationActions.employeeLogout()),
  setIsShowShopifyOrderNotificationModal: (value) =>
    dispatch(shopifyActions.setIsShowShopifyOrderNotificationModal(value)),
  updateShopifyOrderStatus: (
    storeId,
    data,
    gridState,
    toggleOrderDetailsModal
  ) =>
    dispatch(
      shopifyActions.updateShopifyOrderStatus(
        storeId,
        data,
        gridState,
        toggleOrderDetailsModal
      )
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainWrapper);
